import React from "react";
import Login from "../components/Login";

const LoginPage = () => {
  return <Login></Login>;
};

export default LoginPage;
